import React from "react";
import { Routes, BrowserRouter, Route, Navigate, HashRouter } from "react-router-dom";
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ConfirmationServiceProvider } from "./services/ConfirmationService";
import { CustomSnackbarServiceProvider } from "./services/CustomSnackbarService";
import type { } from '@mui/x-date-pickers/themeAugmentation';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import BrowsePage from "./pages/BrowsePage";
import SearchPage from "./pages/SearchPage";
import LoadingPage from "./pages/LoadingPage";
import { CorpusContext } from "./contexts/CorpusContext"
import { TBook } from './resources/types'

const theme = responsiveFontSizes(createTheme());


const AppRoutes = () => {
  const [corpusData, setCorpusData] = React.useState<TBook[]>([])

  React.useEffect(
    () => {
      const readJson = async () => {
        await fetch('corpus.json')
          .then(response => response.json())
          .then(json => {
            console.log(`corpus data retrieved, length = ${json.length}`)
            setCorpusData(json)
          })
          .catch(error => {
            alert(`Error retrieving data`)
          })
      }
      readJson()
    },
    []
  )

  return (
    <CustomSnackbarServiceProvider>
      <ConfirmationServiceProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ThemeProvider theme={theme}>
            {corpusData.length > 0 ?
              <CorpusContext.Provider value={corpusData}>
                <HashRouter>
                  <Routes>
                    <Route path="/browse">
                      <Route index element={<BrowsePage />} />
                      <Route path=":code" element={<BrowsePage />} />
                      <Route path=":code/:page" element={<BrowsePage />} />
                    </Route>
                    <Route path="/search" element={<SearchPage />} />
                    <Route
                      path="*"
                      element={<Navigate to="/browse" replace />}
                    />
                  </Routes>
                </HashRouter>
              </CorpusContext.Provider> : <LoadingPage/>}
          </ThemeProvider>
        </LocalizationProvider>
      </ConfirmationServiceProvider>
    </CustomSnackbarServiceProvider>
  );
};

export default AppRoutes